/**
 * @generated SignedSource<<8513c0506713d9bee2b07e1c01ac55df>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteInsightInput = {
  id: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteInsightMutation$variables = {
  input: DeleteInsightInput;
};
export type deleteInsightMutation$data = {
  readonly deleteInsight: {
    readonly deletedInsightId: string | null;
  } | null;
};
export type deleteInsightMutation = {
  variables: deleteInsightMutation$variables;
  response: deleteInsightMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteInsightPayload",
    "kind": "LinkedField",
    "name": "deleteInsight",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedInsightId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteInsightMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteInsightMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "546dbab9399acbc167bc9877e0474164",
    "id": null,
    "metadata": {},
    "name": "deleteInsightMutation",
    "operationKind": "mutation",
    "text": "mutation deleteInsightMutation(\n  $input: DeleteInsightInput!\n) {\n  deleteInsight(input: $input) {\n    deletedInsightId\n  }\n}\n"
  }
};
})();

(node as any).hash = "f3ecee4ca46c7365ed8ea7557fe89526";

export default node;
